import EmployeeAttributes from "./EmployeeAttributes";
import { useGetEmployeeAttributesQuery } from "types/generated/operations";
import { getProspectUuid } from "utils/idHelpers";
import Loader from "uicomponents/Loader";
import Error from "uicomponents/Error";
interface IEmployeeAttributesProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
}

const EmployeeAttributesModel = ({ ...props }: IEmployeeAttributesProps) => {
  const { data, error, loading } = useGetEmployeeAttributesQuery({
    variables: { uuid: getProspectUuid() },
    fetchPolicy: "no-cache",
  });
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <Error />;
  }
  return (
    <EmployeeAttributes
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
      data={data?.prospect}
    />
  );
};

export default EmployeeAttributesModel;
